<template>
  <div class="report-ld-dw-container">
    <div v-if="isShowSsmc">
      <van-nav-bar
        class="custom-nav-bar"
        title="信息填写"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <template #right>
          <span @click="onTopClickRight" class="nav-link create-team-link">
            创建队伍
          </span>
          <span @click="onBackIndex" class="nav-link home-link">
            &nbsp;&nbsp;主页
          </span>
        </template>
      </van-nav-bar>
    </div>
    <div class="event-title-wrapper" v-if="isShowSsmc">
      <div class="event-title-card">
        {{ SSMC }}
      </div>
    </div>

    <!-- 如果检测到这个人名下有队伍信息，则直接显示列表 -->
    <div v-if="isWriteShow === false">
      <div
        class="team-list-header"
        v-if="isShowSsmc === false && DWLIST.length > 0"
      >
        <van-icon name="chat-o" color="rgb(24, 95, 155)" class="header-icon" />
        <label>队伍信息</label>
      </div>
      <div class="team-item-card" v-for="(item, index) in DWLIST" :key="index">
        <div>
          <van-row class="team-info-row">
            <van-col :span="12">
              <div class="team-name">{{ item.DWJC }}</div>
            </van-col>
            <van-col :span="12">
              <div class="team-leader-info">
                {{
                  (item.LDXM.indexOf("&") > -1
                    ? item.LDXM.split("&")[0]
                    : item.LDXM) +
                    "/" +
                    (item.LDTEL.indexOf("&") > -1
                      ? item.LDTEL.split("&")[0]
                      : item.LDTEL)
                }}
                &nbsp;
                <van-icon name="arrow" />
              </div>
            </van-col>
          </van-row>
        </div>
        <van-divider class="custom-divider" />
        <div class="team-actions" v-if="ssIsBm === 'Y'">
          <van-button
            class="action-btn delete-btn"
            size="mini"
            type="warning"
            @click="createDwNavUrl('DEL', item)"
            >删&nbsp;&nbsp;除</van-button
          >
          <van-button
            class="action-btn edit-btn"
            size="mini"
            type="info"
            @click="editorDwInfo(item)"
            >编&nbsp;&nbsp;辑</van-button
          >
          <van-button
            class="action-btn enter-btn"
            size="mini"
            type="primary"
            @click="cellNavDataUrl(item)"
            >进入报名系统</van-button
          >
        </div>
      </div>
    </div>

    <div v-if="isWriteShow" class="form-wrapper">
      <van-row class="form-section-header">
        <div class="section-header-content">
          <div class="section-title">
            <van-icon name="friends-o" class="section-icon" />
            <label>队伍信息</label>
          </div>
          <div class="required-tip">
            <label><span class="required-star">*</span>号为必填</label>
          </div>
        </div>
      </van-row>
      <div class="form-fields">
        <van-field
          v-model="DWINFO.DWQC"
          required
          class="custom-field"
          label="队伍全称"
          placeholder="请输入队伍全称"
        />
        <van-field
          v-model="DWINFO.DWJC"
          required
          class="custom-field"
          :label="
            ssid ===
            '64563062636e584232646d6937766836726b583373776943612f42337a2b674e'
              ? '股票代码'
              : '队伍简称'
          "
          :placeholder="
            ssid ===
            '64563062636e584232646d6937766836726b583373776943612f42337a2b674e'
              ? '请输入股票代码'
              : '请输入队伍简称'
          "
        />
        <van-field
          v-model="DWINFO.LDXM"
          required
          class="custom-field"
          label="领队姓名"
          placeholder="请输入领队姓名"
        />
        <van-field
          v-model="DWINFO.LDTEL"
          required
          class="custom-field"
          label="赛事负责人手机号"
          placeholder="请输入赛事负责人手机号"
        />
        <van-field
          v-if="
            ssid ===
              '4a76685266752b31494c55775962424a39732b557a6e636a494e4b423677616f'
          "
          v-model="BSLXR"
          required
          class="custom-field"
          label="比赛联系人"
          placeholder="请输入比赛联系人"
        />
        <van-field
          v-if="
            ssid ===
              '4a76685266752b31494c55775962424a39732b557a6e636a494e4b423677616f'
          "
          v-model="BSLXRTEL"
          required
          class="custom-field"
          label="比赛联系人电话"
          placeholder="比赛联系人电话"
        />
      </div>

      <van-row class="form-section-header coach-header">
        <div class="section-header-content">
          <div class="section-title">
            <van-icon name="manager-o" class="section-icon" />
            <label>教练员信息</label>
          </div>
          <div class="add-coach-btn">
            <label class="add-icon-wrapper">
              <van-icon name="add" @click="addJlList" class="add-icon" />
            </label>
          </div>
        </div>
      </van-row>
      <div class="form-fields">
        <van-field
          v-for="(item, index) in DWINFO.JLYLIST"
          :key="index"
          v-model="item.JLXM"
          required
          class="custom-field coach-field"
          label="教练姓名"
          placeholder="请输入教练姓名"
        >
          <template #button>
            <van-button
              class="remove-coach-btn"
              size="small"
              type="danger"
              @click="removeJlList(index)"
              >移除</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="bottom-spacer"></div>
    </div>

    <!--底部按钮  开始-->
    <van-tabbar v-if="isWriteShow === true" class="custom-tabbar">
      <van-tabbar-item class="tabbar-item-wrapper">
        <van-button
          class="cancel-save-btn"
          round
          type="warning"
          @click="removeSave"
        >
          取消保存
        </van-button>
      </van-tabbar-item>
      <van-tabbar-item class="tabbar-item-wrapper">
        <van-button
          class="save-team-btn"
          round
          type="primary"
          @click="createDwNavUrl(btnCzlx, DWINFO)"
        >
          保存队伍信息
        </van-button>
      </van-tabbar-item>
    </van-tabbar>
    <!--底部按钮  结束-->
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  components: { LoadingCom },
  props: {
    ssid: {
      //赛事ID
      type: String,
      default: ""
    },
    isShowSsmc: {
      type: Boolean,
      default: false
    },
    ssIsBm: {
      type: String,
      default: "N"
    }
  },
  data() {
    return {
      BSLXR: "",
      BSLXRTEL: "",
      btnCzlx: "",
      isWriteShow: false,
      utilPost: "",
      op: "wapGL",
      SSMC: "",
      DWLIST: [],
      DWINFO: {
        DWID: "",
        DWQC: "",
        DWJC: "",
        LDXM: "",
        LDTEL: "",
        JLYLIST: []
      }
    };
  },
  mounted() {
    this.utilPost = this.$util.handler;
    var openIdEn = localStorage.getItem("openIdEn");
    var that = this;
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {
        that.$router.push({ path: "/loginIndex" });
      });
    } else {
      var ryInfoLogin = this.utilPost.getLogin();
      if (!ryInfoLogin.isLogin) {
        that.$router.push({ path: "/loginIndex" });
      }
    }
    this.mainData();
  },
  methods: {
    mainData() {
      var busData = {};
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getDwxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.DWLIST = data.content.DWLIST;

        this.SSMC = data.content.SSMC;
        if (this.isShowSsmc) {
          if (this.DWLIST.length === 0) {
            this.isWriteShow = true;
            this.btnCzlx = "ADD";
          } else {
            this.isWriteShow = false;
          }
        }
      });
    },
    removeJlList(index) {
      this.DWINFO.JLYLIST.splice(index, 1);
    },
    addJlList() {
      if (this.DWINFO.JLYLIST.length == 4 || this.DWINFO.JLYLIST.length > 4) {
        alert("教练员不能大于4人");
        return;
      }
      var item = {
        JLXM: ""
      };
      this.DWINFO.JLYLIST.push(item);
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    onTopClickRight() {
      this.DWINFO.DWID = "";
      this.DWINFO.DWJC = "";
      this.DWINFO.DWQC = "";
      this.DWINFO.LDTEL = "";
      this.DWINFO.LDXM = "";
      this.isWriteShow = true;
      this.btnCzlx = "ADD";
    },
    editorDwInfo(rowItem) {
      if (rowItem.LDXM.indexOf("&") > -1) {
        this.DWINFO = rowItem;
        var arrayLdxm = this.DWINFO.LDXM.split("&");
        var arrayLdtel = this.DWINFO.LDTEL.split("&");
        this.DWINFO.LDXM = arrayLdxm[0];
        this.DWINFO.LDTEL = arrayLdtel[0];
        this.BSLXR = arrayLdxm[1];
        this.BSLXRTEL = arrayLdtel[1];
      } else {
        this.DWINFO = rowItem;
      }
      this.isWriteShow = true;
      this.btnCzlx = "UPT";
    },
    createDwNavUrl(type, DWINFO) {
      if (
        DWINFO.DWJC.length === 0 ||
        DWINFO.DWQC.length === 0 ||
        DWINFO.LDXM.length === 0 ||
        DWINFO.LDTEL.length === 0
      ) {
        alert("请检查必填项");
        return;
      }
      if (type !== "DEL") {
        var JLYLIST = this.DWINFO.JLYLIST;
        for (var t = 0; t < JLYLIST.length; t++) {
          var JLXM = JLYLIST[t].JLXM;
          if (JLXM.length === 0) {
            alert("教练员不能为空");
            return;
          }
        }
      }
      if (
        this.ssid ===
          "4a76685266752b31494c55775962424a39732b557a6e636a494e4b423677616f" &&
        type !== "DEL"
      ) {
        if (this.BSLXR.length == 0 || this.BSLXRTEL.length === 0) {
          alert("请填写比赛联系人和电话");
          return;
        }
        DWINFO.LDXM = DWINFO.LDXM + "&" + this.BSLXR;
        DWINFO.LDTEL = DWINFO.LDTEL + "&" + this.BSLXRTEL;
      }

      if (!confirm("是否提交？")) {
        return;
      }
      var busData = {
        DWINFO: DWINFO,
        type: type
      };

      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "inertOrDelOrEditorDwxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          location.reload();
          this.btnCzlx = "";
        }
      });
    },
    cellNavDataUrl(item) {
      this.$router.push({
        path: "/teamRyItemBm",
        query: {
          ssid: this.ssid,
          DWID: item.DWID,
          czlx: "ADD"
        }
      });
    },
    //取消保存
    removeSave() {
      this.isWriteShow = false;
      this.btnCzlx = "";
    },
    onBackIndex() {
      var routeValue = localStorage.getItem("routeValue");
      if (
        routeValue === null ||
        routeValue === undefined ||
        routeValue.length === 0
      ) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: "/" + routeValue });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 容器样式 */
.report-ld-dw-container {
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
}

/* 导航栏样式 */
.custom-nav-bar {
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.3);
}

.custom-nav-bar >>> .van-nav-bar__title {
  color: black;
  font-size: 0.9375rem;
}

.custom-nav-bar >>> .van-nav-bar__text,
.custom-nav-bar >>> .van-icon {
  color: black;
}

.nav-link {
  color: black;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.nav-link:hover {
  opacity: 0.8;
}

.create-team-link {
  font-weight: 500;
}

.home-link {
  font-weight: 500;
}

/* 赛事标题卡片 */
.event-title-wrapper {
  padding: 0.75rem;
}

.event-title-card {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  color: #fff;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  font-size: 0.9375rem;
  font-weight: 700;
  text-align: center;
  box-shadow: 0 4px 16px rgba(24, 95, 155, 0.3);
  letter-spacing: 0.5px;
}

/* 队伍列表头部 */
.team-list-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  background: linear-gradient(
    135deg,
    rgba(24, 95, 155, 0.05) 0%,
    rgba(34, 115, 175, 0.05) 100%
  );
  margin: 0.75rem;
  border-radius: 0.75rem;
  border-left: 3px solid #185f9b;
}

.header-icon {
  font-size: 1rem;
  margin-right: 0.5rem;
}

.team-list-header label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #185f9b;
}

/* 队伍卡片 */
.team-item-card {
  background: #fff;
  margin: 0.625rem 0.75rem;
  padding: 0.875rem;
  border-radius: 0.75rem;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e9ecef;
}

.team-item-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(24, 95, 155, 0.2);
  border-color: #185f9b;
}

.team-info-row {
  margin-bottom: 0.75rem;
}

.team-name {
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
}

.team-leader-info {
  font-size: 0.75rem;
  color: #666;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.custom-divider {
  margin: 0.75rem 0;
  border-color: rgba(24, 95, 155, 0.1);
}

/* 队伍操作按钮 */
.team-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  margin-top: 0.75rem;
}

.action-btn {
  flex: 1;
  border-radius: 0.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  font-size: 0.75rem;
}

.action-btn:active {
  transform: scale(0.95);
}

.delete-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
}

.edit-btn {
  background: linear-gradient(135deg, #4fc3f7 0%, #29b6f6 100%);
  border: none;
}

.enter-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border: none;
}

/* 表单包装器 */
.form-wrapper {
  padding: 0 0.75rem 1rem 0.75rem;
}

/* 表单区域头部 */
.form-section-header {
  margin: 0.75rem 0 0.625rem 0;
  padding: 0;
}

.section-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0.875rem;
  background: linear-gradient(
    135deg,
    rgba(24, 95, 155, 0.05) 0%,
    rgba(34, 115, 175, 0.05) 100%
  );
  border-radius: 0.75rem;
  border-left: 3px solid #185f9b;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: #185f9b;
}

.section-icon {
  font-size: 1rem;
  margin-right: 0.5rem;
  color: #185f9b;
}

.required-tip {
  font-size: 0.75rem;
  color: #999;
}

.required-star {
  color: #ff4d4f;
  font-weight: 700;
  margin-right: 2px;
}

.add-coach-btn {
  cursor: pointer;
}

.add-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(24, 95, 155, 0.3);
}

.add-icon-wrapper:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.4);
}

.add-icon {
  color: #fff;
  font-size: 1rem;
}

.coach-header {
  margin-top: 1.5rem;
}

/* 表单字段 */
.form-fields {
  background: #fff;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.1);
  margin-top: 0.625rem;
  border: 1px solid #e9ecef;
}

.custom-field {
  border-bottom: 1px solid rgba(24, 95, 155, 0.1);
  transition: background 0.3s ease;
}

.custom-field:last-child {
  border-bottom: none;
}

.custom-field:hover {
  background: rgba(24, 95, 155, 0.02);
}

.custom-field >>> .van-field__label {
  color: #333;
  font-weight: 500;
  font-size: 0.8125rem;
}

.custom-field >>> .van-field__control {
  color: #666;
  font-size: 0.8125rem;
}

.custom-field >>> .van-field__control::placeholder {
  color: #ccc;
}

.coach-field >>> .van-field__button {
  padding-left: 0.5rem;
}

.remove-coach-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  border: none;
  color: #fff;
  border-radius: 0.375rem;
  font-size: 0.75rem;
  padding: 0.25rem 0.75rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(255, 107, 107, 0.3);
}

.remove-coach-btn:active {
  transform: scale(0.95);
}

/* 底部间距 */
.bottom-spacer {
  height: 1.25rem;
}

/* 底部标签栏 */
.custom-tabbar {
  background: #fff;
  box-shadow: 0 -2px 12px rgba(24, 95, 155, 0.15);
  border-top: 1px solid rgba(24, 95, 155, 0.1);
}

.tabbar-item-wrapper {
  padding: 0.75rem 1rem;
}

.cancel-save-btn,
.save-team-btn {
  width: 100%;
  height: 2.75rem;
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  box-shadow: 0 4px 12px rgba(24, 95, 155, 0.3);
  transition: all 0.3s ease;
}

.cancel-save-btn {
  background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
}

.save-team-btn {
  background: linear-gradient(135deg, #185f9b 0%, #1a6ba8 100%);
}

.cancel-save-btn:active,
.save-team-btn:active {
  transform: scale(0.98);
}

/* 按钮通用样式 */
.van-button--round {
  height: 2.4375rem;
  font-weight: 600;
  transition: all 0.3s ease;
  width: 9.875rem;
}

.van-button--round:active {
  transform: scale(0.95);
}

.van-card {
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 2px 12px rgba(24, 95, 155, 0.1);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .event-title-wrapper {
    padding: 0.625rem;
  }

  .event-title-card {
    font-size: 0.875rem;
    padding: 0.875rem 0.75rem;
  }

  .team-list-header {
    margin: 0.625rem;
    padding: 0.75rem 0.875rem;
  }

  .team-item-card {
    margin: 0.5rem 0.625rem;
    padding: 0.75rem;
  }

  .team-name {
    font-size: 0.8125rem;
  }

  .action-btn {
    font-size: 0.7rem;
    padding: 0 0.5rem;
  }

  .form-wrapper {
    padding: 0 0.625rem 0.875rem 0.625rem;
  }
}

/deep/ .van-button--mini {
  height: 1.9375rem;
}
</style>



// WEBPACK FOOTER //
// src/components/commonCom/ReportLdDw.vue